module.exports = __webpack_public_path__ + "50ad7c97bfaa2a021d57c4bd3bd539cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-dog-got-it2.png
// module id = 2020
// module chunks = 4